// extracted by mini-css-extract-plugin
export default {"root":"IconArrowHead_root__baLKC","rootTinyArrow":"IconArrowHead_rootTinyArrow__7Woxk"};